import React from "react";
import { graphql, StaticQuery } from "gatsby";
import { useRecoilState } from "recoil";

import { previewDataState } from "src/recoil/atoms";
import getImageObject from "src/helpers/getImageObject";
import Grid from "src/components/UI/Grid/Grid";
import Column from "src/components/UI/Grid/Column";
import Release from "src/components/Modules/Release";
import ArtistItem from "src/components/Modules/Artists/ArtistItem";
import Label from "src/components/UI/Typography/Label";

const RelatedArtist = ({ data, relatedArtist }) => {
  // Get gatsby data
  const { allWpArtist } = data;

  // Set gatsby data
  const gatsbyArtist =
    allWpArtist?.edges?.length > 0
      ? allWpArtist.edges
          .filter(
            ({ node: artist }) =>
              artist.databaseId === relatedArtist.databaseId &&
              !artist.acfArtistPage.hidden
          )
          .map(({ node: artist }) => {
            return {
              id: artist.databaseId,
              title: artist.title,
              link: artist.link,
              image: getImageObject(artist.featuredImage),
              country: artist.acfArtistPage.country,
              release: artist.acfArtistPage.release,
            };
          })[0]
      : null;

  // Get preview data
  const [previewData] = useRecoilState(previewDataState);
  const { artists } = previewData;

  // Set preview data if fetched
  const previewArtist =
    artists?.length > 0
      ? artists.filter(
          (artist) => artist.databaseId === relatedArtist.databaseId
        )[0]
      : null;

  // Choose data based on gatsby or preview mode
  const artist = previewArtist
    ? previewArtist
    : gatsbyArtist
    ? gatsbyArtist
    : null;

  return artist ? (
    <Grid
      flexDirection={["column", null, "row", "row", "column"]}
      alignItems={["center", "flex-start", null, null, "flex-end"]}
      justifyContent="center"
    >
      {artist?.release?.use && (
        <Column
          width={[12 / 12, null, 6 / 12, null, 12 / 12]}
          mb={[5, null, null, null, 8]}
        >
          <Grid
            pl="4"
            flexDirection="row"
            justifyContent={["center", null, "center", null, "flex-end"]}
          >
            <Column width={[12 / 12, null, 11 / 12, null, 9 / 12]}>
              <Release label="Senaste release" release={artist.release} />
            </Column>
          </Grid>
        </Column>
      )}
      <Column width={[12 / 12, null, 6 / 12, null, 12 / 12]}>
        <Grid justifyContent={["center", null, null, null, "flex-end"]}>
          <Column width={[12 / 12, null, 11 / 12, null, 9 / 12]}>
            <Label mb="5">Om artisten</Label>
            <ArtistItem
              name={artist.title}
              image={artist.image}
              link={artist.link}
              country={artist.country}
            />
          </Column>
        </Grid>
      </Column>
    </Grid>
  ) : null;
};

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        allWpArtist {
          edges {
            node {
              databaseId
              title
              link
              featuredImage {
                node {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(
                        layout: CONSTRAINED
                        placeholder: DOMINANT_COLOR
                        width: 1920
                      )
                    }
                  }
                }
              }
              acfArtistPage {
                country
                release {
                  use
                  title
                  image {
                    localFile {
                      childImageSharp {
                        gatsbyImageData(
                          layout: CONSTRAINED
                          placeholder: DOMINANT_COLOR
                          width: 1920
                        )
                      }
                    }
                  }
                  spotifyUri
                }
                hidden
              }
            }
          }
        }
      }
    `}
    render={(data) => <RelatedArtist data={data} {...props} />}
  />
);
